export const LOCAL_STORAGE_SAVED_DOMAIN_KEY = "custom_domains_saved_domain";
